<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="ml"
      :title="$t('workflow.path')"
    >
      <!-- {{ id }} -->
      <h2>{{ $t("workflow.path") }}</h2>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data">
          <router-link :to="'/workflow/pathEdit/' + data.item.id">
            <b-button size="sm">
              {{ $t('geral.view') }}
            </b-button>
          </router-link>
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button class="ml-2" variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "WaypointTripPlansModal",
  props: {
    id: Number,
  },
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "name",
          filterKey: "name",
          label: "Nome",
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          formatter: (value, key, item) => {
            if (item.active) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: {
        id: "",
        name: "",
        active: "true",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
      };
      this.$apiWorkflow
        .post("/tripPlan/GetByWaypointId/" + this.id, apiParam)
        .then((response) => {
          const items = response.data.items;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.actions {
  min-width: 300px;
}
</style>